<template>    
	<div v-loading="dataLoading">
		<el-form  :model="formData" :rules="rules" ref="formData">                
			<el-row :gutter="30">
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item prop="cpsName" label="计划名称：" required>
						<el-input v-model="formData.cpsName" :maxlength="20"></el-input>
					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item prop="telephone" label="联系人手机：" required>
						<el-input v-model="formData.telephone" :maxlength="11" type="number"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="30">
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item prop="contentType" required>
						<span slot="label">定向计划类型：<small><span class="color-warning">注意: 创建的时候就要选好, 后续不能修改, 短视频额外需要投稿开始结束时间</span></small></span>
						<el-radio-group v-model="formData.contentType">
							<el-radio :label="1">仅短视频：<small>（达人围绕商单定制视频内容，节奏短平快，存在周期长，可持续转化订单。）</small></el-radio><br>
							<el-radio :label="2" class="MT15">仅直播间：<small>（达人围绕商单进行直播带货，强即时性+互动性，短期内订单转化效果更明显。）</small></el-radio>
						</el-radio-group>
					</el-form-item>
				</el-col>				
			</el-row>
			<el-row :gutter="30" v-if="formData.contentType == 1">
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item prop="datetimerange"  required>
						<span slot="label">上传投稿短视频时间段：</span>						
						<el-date-picker
						    v-model="formData.datetimerange"
						    type="datetimerange"
						    start-placeholder="开始时间"
						    end-placeholder="结束时间"
						    value-format="yyyy-MM-dd HH:mm:ss"
						    size="medium"
						    unlink-panels
						></el-date-picker>
						<div class="MT10">
							<small>
								<span class="color-warning">时间段选择，至少设置到分钟级别。时间要遵循如下规则，否则无法通过<br>创建的时候注意 now< start time < end_ time<br>
	修改的时候注意 now< new start time < old start time < old end time < new end time<br></span>
								<span class="color-danger">当计划已经开始（start time < now）,该计划将无法再修改,无法取消,这一点要特别注意</span>
							</small>
						</div>
					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item prop="expirationDate"  required>
						<span slot="label">佣金有效期：<small><span class="color-warning">单位是天,创建计划时必填，</span><span class="color-danger">修改计划时无需填写，不可修改</span></small></span><br>
						 <el-input-number style="width:90%;" v-model="formData.expirationDate" :min="1" :max="365"
						:controls="false" :precision='0' ></el-input-number> 天
					</el-form-item>
				</el-col>
			</el-row>			
			<el-row :gutter="30">
				<el-col :xs="24" :xl="16">
					<el-form-item>
						<p><span slot="label"><span class="color-danger">*</span>达人抖音号：<small><span class="color-warning">注意是达人的抖音号, 创建成功后还可以修改(进行中的达人可以删除), 最多200 个</span></small></span></p>
						<div class="douyinUserList">
							<ul v-if="douyinUserList && douyinUserList.length > 0">
								<li v-for="(item, index) in douyinUserList" >{{item.name}} <el-button type="text"  size="small" icon="el-icon-close" @click="removeUser(index)">删除</el-button></li>								
							</ul>
						</div>
						<div class="MT10">
							<el-input v-model="addDouyinuser" style="width: 85%;"></el-input> <el-button  icon="el-icon-plus" size="mini" type="primary" @click="addUser()">新增</el-button>
						</div>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="30">
				<el-col :xs="24" :xl="16">
					<el-form-item>
						<div><span slot="label"><span class="color-danger">*</span>选择演出：</span></div>												
						<el-card class="MT20">
							<div class="page-list-box">
							   <el-table :data="formData.activityList" border style="width: 100%" size="small" stripe>
							        <el-table-column prop="activityId" label="演出ID" show-overflow-tooltip></el-table-column>
							        <el-table-column prop="title" label="演出名称"></el-table-column>
							        <el-table-column prop="douyinPoiId" label="抖音ID"></el-table-column>
									<el-table-column prop="ratio" label="佣金比例: ">
										<template slot-scope="scope">
											<el-input-number style="width:30%;" v-model="scope.row.ratio" :min="1" :max="29"
											    :controls="false" :precision='1'></el-input-number> %
												<small class="color-danger"> 1% - 29% 之间</small>
										</template>
									</el-table-column>							       
							        <el-table-column fixed="right" label="操作" width="100">
							            <template slot-scope="scope">
							                <el-button
							                    v-if="$utils.have('/activity/cps/userDetailList')"
							                    type="text"
							                    size="small"
												@click="removeActivity(scope.$index)"
							                    >删除</el-button
							                >
							            </template>
							        </el-table-column>
							    </el-table>				
							</div>
						</el-card>
					</el-form-item>
					<small><span class="color-warning">每个演出单独设置佣金比例 , 只能选择目前在抖音上架的演出<br><span class="color-danger">演出在定向计划创建后不可以删除</span>, 只可以修改佣金比例,一个计划最多 50 个演出</span></small>
					<div class="MT20">
						<el-button
						    type="primary"
						    size="small"
							@click="$refs.selectActivity.show()"
						    >选择演出</el-button
						>
						<span class="ML20" v-if="formData.activityList && formData.activityList.length >0 ">当前已添加<span class="color-danger"> {{formData.activityList.length}} </span>个演出</span>
					</div>
				</el-col>				
			</el-row>
			
			
		</el-form>
		<div class="page-btns-box MT20">
			<el-button @click="goBack()" >返 回</el-button>
			<el-button type="primary" @click="submitForm()" :loading="btnLoading">确 定</el-button>
		</div>
		<select-activity ref="selectActivity"  :formData.sync="formData"></select-activity>
	</div>   
</template>
<script>
import SelectActivity from './components/SelectActivity.vue'
const defaultData = {
    cpsName: "",
    telephone: "",
	contentType:"",
	talentDouyinIdList:[],
	activityList:[],
	datetimerange:[],
	expirationDate:'',
	id:''
    
}
export default {
    props: {
        id: {
            type: [Number, String],
            default: ""
        }
    },
    components:{
        SelectActivity
    },
    data() {
		var validatePhone = (rule, value, callback) => {
		    const _reg = /^\d{11}$/;
		    if (!_reg.test(value)) {
		        callback(new Error("请填写11位的手机号"));
		    } else {
		        callback();
		    }
		};
        return {
            formData: {
                ...defaultData
            },
			rules:{
				cpsName:[{required: true, message: "请输入计划名称"}],
				telephone:[
					{required: true, message: "请输入手机号码"},
					{ validator: validatePhone },
				],
				datetimerange:[{ required: true, message: "请填写上传投稿短视频时间段" }],
				expirationDate:[{required: true, message: "请输入佣金有效期"}],
				contentType:[{required: true, message: "请选择定向计划类型"}],
			},
			douyinUserList:[],
			dataLoading:false,
			btnLoading:false,
			userLoading:false,
			userList:[],
			addDouyinuser:'',
			ratio:'',
			redirect: this.$route.query.redirect || '',
			
        }
    },
    computed: {
        status() {
            return {
                1: '进行中', 2: '暂停中', 3: '已结束'
            }
        },
        contentType() {
            return {
                1: '仅短视频', 2: '仅直播间',
            }
        }
    },
    mounted() {
        
    },
    methods: {
       
		addUser(){
			if( this.addDouyinuser == ''){
				return this.$message.error("请先输入达人抖音号");
			}else{
						
				var _index = this.douyinUserList.length				
				var name = this.addDouyinuser
				this.douyinUserList.push({
				    name:name,
				    index:_index++,
				})
				//this.douyinUserList = _data
				this.addDouyinuser = ''
				
			}			
		},
		removeUser(index){
			
			if( this.douyinUserList.length > 0){
				this.douyinUserList.forEach((tab, idx) => {					
				   if( index === idx){
					   this.douyinUserList.splice(index,1)
				   }
				})				
			}
			
		},
		removeActivity(index){			
			if( this.formData.activityList.length > 0){
				this.formData.activityList.forEach((tab, idx) => {					
				   if( index == idx){
					  this.formData.activityList.splice(index,1)
				   }
				})				
			}
		},
       //返回
       goBack() {
           if (this.redirect) {
               this.$router.push({
                   path: this.redirect,
               });
           } else {
               this.$router.go(-1);
           }
       },
		// 提交
		submitForm() {
			var _douyinUserList = []
			if( this.douyinUserList.length == 0 ){
				return this.$message.warning('达人抖音号不能为空！')
			}else{
				this.douyinUserList.forEach((tab, idx) => {
					 _douyinUserList.push(tab.name)
				})
				
			}
			this.formData.talentDouyinIdList = _douyinUserList
			
			if( this.formData.activityList && this.formData.activityList.length == 0 ){
				return this.$message.warning('演出不能为空！')
			}
			this.formData.startTime = this.formData.datetimerange[0];
			this.formData.endTime = this.formData.datetimerange[1];
			
		   this.$refs["formData"].validate(async (valid) => {
		       
		        if (valid) {
		            this.btnLoading = true;
		            this.$request({
		                url: '/activity/cps/oriented/save',
		                data:this.formData,		                
		                method: "post",
		            })
		                .then((res) => {
		                    const { state, msg } = res.data;
		                    if (state == 1) {
		                        this.goBack();
		                    } else {
		                        this.$message.error(msg || "操作失败,请重试");
		                    }
		                })
		                .catch(() => {
		                    this.$message.error("操作失败,请重试");
		                })
		                .finally(() => {
		                    this.btnLoading = false;
		                });
		        } else {
		            return false;
		        }
		    });
		},
        //导出
        download(){
            this.downLoading = true;
            this.$request({
                url: "/activity/cps/oriented/downloadDetail",
                method: "POST",
                params: {
                    activityId: this.id,
                },
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1 ) {
                        this.$confirm('下载任务创建成功,可以在下载任务列表查看', '提示', {
                            confirmButtonText: '立即查看',
                            cancelButtonText: '稍后再看',
                            type: 'success',
                            center: true,
                            closeOnClickModal: false
                        }).then(() => {
                            this.$router.push({path:'/workbench/downloadList'})
                        }).catch(() => {})
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.downLoading = false;
                });
        },
    }
}
</script>
<style lang="scss" scoped>

.douyinUserList li{
	display: inline-block;
	margin-right: 20px;
}
</style>